import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  IconButton,
  Button,
  Tooltip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip
} from '@mui/material';

import {
  ExpandMore,
  Delete,
  PictureAsPdf,
  Visibility,
  Edit,
  Add
} from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../auth/AuthContext';
import ProtectedAction from './ProtectedAction';
import { formatDate } from '../utils/dateFormatter';

import annoFiscaleApi from '../api/annoFiscaleApi';
import praticaApi from '../api/praticaApi';

const tipiDocumento = [
  'MULTA',
  'PAGOPA',
  'RATEIZZAZIONE_ADE',
  'ROTTAMAZIONE',
  'AMA',
  'ACCERTAMENTO_TARI',
  'F24',
  'FF24PREDETERMINATO',
  'TARI',
  'INTIMAZIONEPAG_AGRISC',
  'BOLLOAUTO',
  'INARCASSA',
  'FATTURA_PASSIVA',
  'FATTURA_ATTIVA',
  'ALTRO'
];

export default function DocumentoFascicoloTable({
  documenti,
  contribuenteId,
  fascicoloId,
  onDownload,
  onDelete
}) {

  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  const [anniFiscali, setAnniFiscali] = useState([]);
  const [tabAnno, setTabAnno] = useState(0);
  console.log("DocumentoFascicoloTable contribuenteId",contribuenteId);
  useEffect(() => {
    fetchAnniFiscali();
  }, [fascicoloId]);

  const getPraticaStatusColor = (stato) => {
    switch (stato) {
      case 'APERTA':
        return 'info';

      case 'IN_ATTESA_DOCUMENTI':
        return 'warning';

      case 'COMPLETATA':
        return 'success';

      case 'CHIUSA':
        return 'error';

      default:
        return 'default';
    }
  };

  const fetchAnniFiscali = async () => {
    try {
      console.log("fetchAnniFiscali contribuenteId ",contribuenteId);
      const res = await annoFiscaleApi.getByContribuente(contribuenteId);
      console.log("anni",res.data);
      const anniConPratiche = await Promise.all(
        res.data.map(async (anno) => {
          console.log("anno",anno.anno+ " " +anno.id);
          const praticheRes = await praticaApi.getByAnnoFiscale(anno.id);

          return {
            ...anno,
            pratiche: praticheRes.data || []
          };

        })
      );
      console.log("anniConPratiche ",anniConPratiche);
      setAnniFiscali(anniConPratiche);

    } catch (err) {
      console.error(err);
    }
  };

  const handleCreaScadenze = (doc) => {

    navigate(
      `/contribuenti/${contribuenteId}/documenti/upload`,
      {
        state: {
          documentoFascicoloId: doc.id
        }
      }
    );
  };

  const handleNuovoDocumento = (annoFiscaleId, praticaId = null) => {

    navigate(
      `/fascicolo/${fascicoloId}/documento/create`,
      {
        state: {
          annoFiscaleId,
          praticaId,
          contribuenteId
        }
      }
    );
  };

  const handleNuovaPratica = (annoFiscaleId,anno) => {

    navigate(
      `/fascicolo/${fascicoloId}/pratiche/create`,
      {
        state: {
          annoFiscaleId,
          anno
        }
      }
    );
  };

  const renderDocumentoRow = (d) => (
    <TableRow key={d.id}>

      <TableCell>{d.tipo}</TableCell>

      <TableCell>{d.descrizione}</TableCell>

      <TableCell>{d.versione}</TableCell>

      <TableCell>{formatDate(d.dataUpload)}</TableCell>

      <TableCell>{d.caricatoDa}</TableCell>
        <TableCell>
        <Stack direction="row" spacing={1} flexWrap="wrap">

          <ProtectedAction
            user={user}
            contractState={user.statoContratto}
          >

            <Tooltip title="Apri PDF">
              <IconButton
                color="error"
                onClick={() => onDownload(d.id, d.nomeFile)}
              >
                <PictureAsPdf />
              </IconButton>
            </Tooltip>

            <Tooltip title="Elimina">
              <IconButton
                color="error"
                onClick={() => onDelete(d.id)}
              >
                <Delete />
              </IconButton>
            </Tooltip>

            {(
              (d.parsedandloaded == null || d.parsedandloaded !== true)
              && tipiDocumento.includes(d.tipo)
            ) && (
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => handleCreaScadenze(d)}
              >
                Crea Scadenze
              </Button>
            )}

            {d.documentoId && (
              <Tooltip title="Visualizza Scadenze">
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => navigate(`/documenti/${d.documentoId}`)}
                >
                  <Visibility />
                </IconButton>
              </Tooltip>
            )}

          </ProtectedAction>

        </Stack>

      </TableCell>

    </TableRow>
  );

  const renderDocumentiTable = (docs) => {

    if (!docs || docs.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary">
          Nessun documento presente
        </Typography>
      );
    }

    return (
      <Table>

        <TableHead>

          <TableRow>
            <TableCell>Tipo</TableCell>
            <TableCell>Descrizione</TableCell>
            <TableCell>Versione</TableCell>
            <TableCell>Data Caricamento</TableCell>
            <TableCell>Caricato Da</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>

        </TableHead>

        <TableBody>
          {docs.map(renderDocumentoRow)}
        </TableBody>

      </Table>
    );
  };

  const documentiSenzaPratica = documenti.filter(
    d => !d.praticaId
  );

  return (
    <Box>

      {/* HEADER AZIONI */}

      <Stack
        direction="row"
        spacing={2}
        sx={{ mb: 2 }}
        flexWrap="wrap"
      >

        <Button
          variant="contained"
          startIcon={<Add />}
            onClick={() =>
              navigate(`/fascicolo/${fascicoloId}/annofiscale/create`, {
                state: { contribuenteId }
              })
            }
        >
          Nuovo Anno Fiscale
        </Button>

      </Stack>

      {/* TABS ANNI */}

      <Tabs
        value={tabAnno}
        onChange={(e, value) => setTabAnno(value)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3 }}
      >

        {anniFiscali.map((anno) => (
          <Tab
            key={anno.id}
            label={`Anno ${anno.anno}`}
          />
        ))}

        <Tab label="Senza pratica" />

      </Tabs>

      {/* TAB SENZA PRATICA */}

      {tabAnno === anniFiscali.length && (
        <Box>

          <Typography
            variant="h6"
            sx={{ mb: 2 }}
          >
            Carica documento
          </Typography>

          {renderDocumentiTable(documentiSenzaPratica)}

        </Box>
      )}

      {/* TABS ANNI FISCALI */}

      {anniFiscali.map((anno, index) => {

        if (tabAnno !== index) {
          return null;
        }

        return (
          <Box key={anno.id}>

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2 }}
            >

              <Stack direction="row" spacing={1}>

                <Chip
                  label={`Anno fiscale ${anno.anno}`}
                  color="primary"
                />

              </Stack>

              <Stack direction="row" spacing={1}>

                <Button
                  variant="outlined"
                  startIcon={<Add />}
                  onClick={() => handleNuovaPratica(anno.id,anno.anno)}
                >
                  Nuova pratica
                </Button>

                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => handleNuovoDocumento(anno.id)}
                >
                  Documento senza pratica
                </Button>

              </Stack>

            </Stack>

            {/* PRATICHE */}

            {anno.pratiche?.map((pratica) => {

              const docsPratica = documenti.filter(
                d => d.praticaId === pratica.id
              );

              return (
                <Accordion
                  key={pratica.id}
                  sx={{ mb: 2 }}
                >

                  <AccordionSummary expandIcon={<ExpandMore />}>

                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                    >

                      <Typography fontWeight={600}>
                        {pratica.nome}
                      </Typography>

                      <Chip
                        size="small"
                        label={docsPratica.length + ' documenti'}
                      />
                        <Chip
                          label={pratica.stato}
                          color={getPraticaStatusColor(pratica.stato)}
                        />
                        <IconButton
                          color="primary"
                          onClick={() => navigate(`/fascicolo/pratiche/${pratica.id}/edit`)}
                        >
                          <Edit />
                        </IconButton>
                    </Stack>

                  </AccordionSummary>

                  <AccordionDetails>

                    <Stack
                      direction="row"
                      justifyContent="flex-end"
                      sx={{ mb: 2 }}
                    >

                      <Button
                        variant="contained"
                        startIcon={<Add />}
                        onClick={() =>
                          handleNuovoDocumento(
                            anno.id,
                            pratica.id
                          )
                        }
                      >
                        Carica Documento
                      </Button>

                    </Stack>

                    {renderDocumentiTable(docsPratica)}

                  </AccordionDetails>

                </Accordion>
              );

            })}

            {(!anno.pratiche || anno.pratiche.length === 0) && (
              <Typography
                variant="body2"
                color="text.secondary"
              >
                Nessuna pratica presente
              </Typography>
            )}

          </Box>
        );

      })}

    </Box>
  );
}